import React from 'react'

const Social = () => {
    return(
        <div className="home__social">
            <a href="https://www.linkedin.com/in/abdulhamidshahade/" 
               className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-linkedin-alt"></i>
            </a>
            <a href="https://github.com/abdulhamidshahade" 
               className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github-alt"></i>
            </a>
            <a href="https://www.youtube.com/@AbdulhamidShahade" 
               className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-youtube color-white"></i>
            </a>
        </div>
    )
}

export default Social;
